export function findApiErrorMessage(error: any) {
  return (
    error?.errorMessage ||
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    "Something went wrong. Please try again or contact support if the error persists."
  );
}
